import { render, staticRenderFns } from "./AdditSemester.vue?vue&type=template&id=1ec35b98&"
import script from "./AdditSemester.vue?vue&type=script&lang=js&"
export * from "./AdditSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports